<template>
    <div v-if="user.isAdmin">
        <div class="flex flex-wrap flex-col md:flex-row">
            <div class="w-full md:w-1/2">
                <h1 class="mt-2 mb-4 md:mb-0 font-sans text-n-gray-dark">Organizations</h1>
            </div>
            <div class="w-full md:w-1/2 md:text-right mb-5 md:mb-0">
                <a href="#" class="button mb-12" @click.stop.prevent="syncOrganizations">Sync Organizations</a>
            </div>
        </div>

        <div class="flex flex-wrap">
            <div class="flex-1 mb-3">
                <input type="text" placeholder="Search for organization name" class="mb-4 search"
                    v-on:keyup.enter="searchOrganizations"
                    v-model="keyword">
            </div>
            <div class="w-full md:w-1/5">
                <button href="/events/create" class="button mb-2" @click.stop.prevent="searchOrganizations">Search</button>
            </div>
            <div class="w-full md:w-1/5">
                <button href="/events/create" class="button mb-2" @click.stop.prevent="clearSearch">Clear</button>
            </div>
        </div>
        <div class="responsive-table">
            <table class="w-full">
                <thead>
                    <tr>
                        <th>Organization</th>
                        <th>Url</th>
                    </tr>
                </thead>
                <tr v-if="this.isSearching && this.searchedOrganizations.length < 1">
                    <td colspan="5" class="text-center font-bold">No search results</td>
                </tr>
                <organization-item
                    v-else
                    v-for="organization in filteredOrganizations"
                    :key="organization.id"
                    :organization="organization"></organization-item>
            </table>
        </div>

        <div class="flex mt-8">
            <div class="w-1/2">
            <button class="mt-2"
                @click.stop.prevent="previous"
                :disabled="currentPage === 1"
                :class="{'opacity-50 cursor-not-allowed': currentPage === 1}">&lt;&lt; Previous</button>
            </div>

            <div class="w-1/2 text-right">
            <button class="mt-2"
                @click.stop.prevent="next"
                :disabled="currentPage === totalPages"
                :class="{'opacity-50 cursor-not-allowed': currentPage === totalPages}">Next &gt;&gt;</button>
            </div>
        </div>
    </div>
</template>

<script>

    import {mapGetters} from 'vuex';
    import OrganizationItem from './OrganizationItem.vue'

    export default {
        name: 'OrganizationList',
        title: 'Organization List',
        components: {
            'organization-item': OrganizationItem
        },
        data() {
            return {
                keyword: '',
                searchedOrganizations: {},
                isSearching: false,
                searchPagination: {
                    current_page: 1
                },
            }
        },
        computed: {
            ...mapGetters({
                user: 'user',
                organizations: 'organizations',
                pagination: 'organizationPagination',
            }),
            filteredOrganizations() {
                return ( this.searchedOrganizations.length > 0 ) ? this.searchedOrganizations : this.organizations
            },
            totalRecords() {
                return Object.keys(this.organizations).length
            },
            currentPage() {
                if(this.isSearching) {
                    return this.searchPagination.current_page
                }
                return this.pagination.current_page
            },
            totalPages() {
                if(this.isSearching) {
                    return this.searchPagination.last_page
                }
                return this.pagination.last_page
            }
        },
        watch: {},
        methods: {
            previous() {
                if(this.isSearching) {
                    this.searchPagination.current_page = this.searchPagination.current_page - 1
                    this.searchOrganizations()
                } else {
                    var page = this.currentPage - 1
                    this.$store.dispatch('getMoreOrganizations', {page: page})
                }
                window.scrollTo(0, 0);
            },
            next() {
                if(this.isSearching) {
                    this.searchPagination.current_page = this.searchPagination.current_page + 1
                    this.searchOrganizations()
                } else {
                    var page = this.currentPage + 1
                    this.$store.dispatch('getMoreOrganizations', {page: page})
                }
                window.scrollTo(0, 0);
            },
            clearSearch() {
                this.searchedOrganizations = {}
                this.keyword = ''
                this.searchPagination = {
                    current_page: 1
                }
                this.isSearching = false
            },
            searchOrganizations() {
                this.isSearching = true

                axios.get(laroute.route('api.organizations.search', {
                    keyword: this.keyword,
                    page: this.currentPage
                }))
                    .then((response) => {
                        this.searchedOrganizations = response.data.data
                        this.searchPagination = response.data.meta
                    })
            },
            syncOrganizations() {
                this.$toasted.show('Syncing resources...')

                var route = this.$laroute.route('api.organizations.sync')

                axios.post(route)
                    .then((response) => {
                        this.$toasted.show('Resources have been synced.')
                    })
                    .catch((error) => {
                        console.log(error)
                        console.log(error.response)
                    })
            }
        },
        mounted() {
            this.$store.dispatch('getOrganizations')

        }
    }
</script>
